module.exports = __webpack_public_path__ + "assets/normal/images/reset-permission-es.86fd26d1.png";